import React from 'react';
import { Link } from 'react-router-dom';

const footerColumns = [
  {
    title: "L'Organizzazione",
    links: [
      { label: 'Chi Siamo', path: '/chi-siamo' },
      { label: 'Organizzazione', path: '/organizzazione' },
      { label: 'Segreteria Nazionale', path: '/segreteria' },
      { label: 'Segretari Territoriali', path: '/segretari' },
      { label: 'Eletti', path: '/eletti' },
      { label: 'Documenti', path: '/documenti' },
    ],
  },
  {
    title: 'Il Territorio',
    links: [
      { label: 'Circoli', path: '/circoli' },
      { label: 'Federazioni Regionali', path: '/federazioni-regionali' },
      { label: 'Federazioni Provinciali', path: '/federazioni-provinciali' },
      { label: 'Partecipa', path: '/partecipa' },
      { label: 'Eventi', path: '/eventi' },
      { label: 'Contatti', path: '/contatti' },
      { label: 'FAQ', path: '/faq' },
    ],
  },
  {
    title: 'News & Media',
    links: [
      { label: 'Notizie', path: '/notizie' },
      { label: 'Video', path: '/video' },
      { label: 'Podcast', path: '/podcast' },
      { label: 'Area Stampa', path: '/stampa' },
    ],
  },
];

const socialLinks = [
  { label: 'Facebook', text: 'f' },
  { label: 'Instagram', text: 'ig' },
  { label: 'Twitter/X', text: 'x' },
  { label: 'YouTube', text: 'yt' },
  { label: 'TikTok', text: 'tk' },
];

const Footer = () => {
  return (
    <footer className="footer" role="contentinfo">
      <div className="container">
        <div className="footer__top">
          <div className="footer__brand">
            <div className="footer__brand-logo" style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
              <img src="/logo-gd.svg" alt="Giovani Democratici Logo" style={{ width: 48, height: 48 }} />
              <div className="footer__brand-name">Giovani Democratici</div>
            </div>
            <p>
              L'organizzazione giovanile del Partito Democratico. In tutta
              Italia, per costruire la politica di domani.
            </p>
            <div className="footer__social">
              {socialLinks.map((s) => (
                <a
                  href="#"
                  className="footer__social-link"
                  aria-label={s.label}
                  key={s.label}
                >
                  {s.text}
                </a>
              ))}
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <div className="footer__col-title">{col.title}</div>
              <div className="footer__links">
                {col.links.map((link) => (
                  <Link to={link.path} className="footer__link" key={link.path}>
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="footer__bottom">
          <span>© 2026 Giovani Democratici. Tutti i diritti riservati.</span>
          <div className="footer__bottom-links">
            <a href="#">Privacy Policy</a>
            <a href="#">Cookie Policy</a>
            <a href="#">Note Legali</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
